const weatherConditionsFieldsSelector = ['fields.conditions'].join(',')

export default weatherConditionsFieldsSelector
